import gsap from 'gsap';

export default function initSearch() {
    const search = document.querySelector('.search');
    const openBtns = document.querySelectorAll('.header-search');
    const closeBtn = document.querySelector('.search-close');
    const input = search?.querySelector('.search-input');

    if (!search || !openBtns.length || !closeBtn) return;

    const tl = gsap.timeline({
        paused: true,
        defaults: { duration: 0.4, ease: 'power3.out' }
    });

    tl.to(search, {
        autoAlpha: 1,
        pointerEvents: 'all'
    });

    // Animate search body components
    const searchBody = search.querySelector('.search__body__form');
    if (searchBody) {
        tl.fromTo(searchBody, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1
        }, '<0.1');
    }

    const openSearch = (e) => {
        if (e) e.preventDefault();
        tl.timeScale(1).play();
        setTimeout(() => {
            if (input) input.focus({ preventScroll: true });
        }, 500);
    };

    const closeSearch = (e) => {
        if (e) e.preventDefault();
        tl.timeScale(1.5).reverse();
    };

    openBtns.forEach(btn => btn.addEventListener('click', openSearch));
    closeBtn.addEventListener('click', closeSearch);

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && search.style.visibility !== 'hidden') {
            closeSearch();
        }
    });
}
